"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const Dataset_1 = require("../Dataset");
/**
 * Token Dataset
 */
class TokenDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        /**
         * Create token.
         *
         * @param req Use {@link Build5Request} with data based on {@link TokenCreateRequest}
         * @returns
         */
        this.create = (req) => this.sendRequest(interfaces_1.WEN_FUNC.createToken)(req);
        /**
         * Update token.
         *
         * @param req Use {@link Build5Request} with data based on {@link TokenUpdateRequest}
         * @returns
         */
        this.update = (req) => this.sendRequest(interfaces_1.WEN_FUNC.updateToken)(req);
        /**
         * Set token for sale on the launchpad.
         *
         * @param req Use {@link Build5Request} with data based on {@link SetTokenForSaleRequest}
         * @returns
         */
        this.setAvailableForSale = (req) => this.sendRequest(interfaces_1.WEN_FUNC.setTokenAvailableForSale)(req);
        /**
         * Cancel public token sale.
         *
         * @param req Use {@link Build5Request} with data based on {@link CanelPublicSaleRequest}
         * @returns
         */
        this.cancelPublicSale = (req) => this.sendRequest(interfaces_1.WEN_FUNC.cancelPublicSale)(req);
        /**
         * Order Token request.
         *
         * @param req Use {@link Build5Request} with data based on {@link OrderTokenRequest}
         * @returns
         */
        this.order = (req) => this.sendRequest(interfaces_1.WEN_FUNC.orderToken)(req);
        /**
         * Credit token request.
         *
         * @param req Use {@link Build5Request} with data based on {@link CreditTokenRequest}
         * @returns
         */
        this.credit = (req) => this.sendRequest(interfaces_1.WEN_FUNC.creditToken)(req);
        /**
         * Update member details.
         *
         * @param req Use {@link Build5Request} with data based on {@link MemberUpdateRequest}
         * @returns
         */
        this.mint = (req) => this.sendRequest(interfaces_1.WEN_FUNC.mintTokenOrder)(req);
        /**
         * Enable token for trading on a exchange.
         *
         * @param req Use {@link Build5Request} with data based on {@link EnableTokenTradingRequest}
         * @returns
         */
        this.enableTrading = (req) => this.sendRequest(interfaces_1.WEN_FUNC.enableTokenTrading)(req);
        /**
         * Imported minted token from the chain.
         *
         * @param req Use {@link Build5Request} with data based on {@link ImportMintedTokenRequest}
         * @returns
         */
        this.importMintedToken = (req) => this.sendRequest(interfaces_1.WEN_FUNC.importMintedToken)(req);
        /**
         * Vote on token.
         *
         * @param req Use {@link Build5Request} with data based on {@link VoteRequest}
         * @returns
         */
        this.vote = (req) => this.sendRequest(interfaces_1.WEN_FUNC.voteController)(req);
        /**
         * Rank token.
         *
         * @param req Use {@link Build5Request} with data based on {@link RankRequest}
         * @returns
         */
        this.rank = (req) => this.sendRequest(interfaces_1.WEN_FUNC.rankController)(req);
        /**
         * Get tokens by member. Real time stream.
         * @param member
         * @param startAfter
         * @param limit
         * @returns
         */
        this.getByMemberLive = (member, startAfter, limit) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['member'],
                fieldValue: [member],
                operator: [interfaces_1.Opr.EQUAL],
                startAfter,
                limit,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        /**
         * Get status for token. Real time stream.
         * @param status
         * @param startAfter
         * @param limit
         * @returns
         */
        this.getByStatusLive = (status = [], startAfter, limit) => {
            const params = {
                dataset: this.dataset,
                fieldName: status.map(() => 'status').concat('public'),
                fieldValue: status.concat(true),
                operator: status.map(() => interfaces_1.Opr.EQUAL).concat(interfaces_1.Opr.EQUAL),
                startAfter,
                limit,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.TokenDataset = TokenDataset;
